import { t } from '../translations.js';
import { Button } from '../ui/button.js';

/**
 * Body of the new-version toast (`registerNewVersionHandling`): the
 * explanation with the reload control underneath it as a primary button.
 * sonner's inline `action` slot would squeeze the text into a narrow column
 * beside a dark pill; stacking keeps the copy readable at toast width.
 */
export function NewVersionToast({ onReload }: { onReload: () => void }) {
  return (
    <div className="flex flex-col items-start gap-3">
      <p>{t.app.newVersion.toastDescription}</p>
      <Button size="sm" onClick={onReload} data-testid="new-version-toast-reload-btn">
        {t.app.newVersion.reload}
      </Button>
    </div>
  );
}
